module.exports = __webpack_public_path__ + "img/sr3-cover.eaedddd2.jpg";